import Tabs from "components/lib/Shared/Tabs";
import ManualTransactionEditContext from "context/ManualTransactionEditContext";
import UpdateCompanyDetailsContext from "context/UpdateCompanyDetails";
import { useContext, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import AnnualCompliance from "./AnnualCompliance";
import CompanySummary from "./CompanySummary";
import Governance from "./Governance";
import Securities from "./Securities";
import { Constants } from "config/constants";

const Summary = ({ handleGoBack, handleGoForward }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const { company, dashboardRoles } = useSelector(
    (state) => state.companyDashboardSlice
  );
  const { contactPerson, articlesOfAssociation } = company;

  const templateVersions = articlesOfAssociation?.template?.versions ?? [];

  const latestTemplateVersion =
    templateVersions.length > 0
      ? templateVersions[templateVersions.length - 1]
      : [];

  const { isInUpdateCompanyDetailsContext, selectionsMade, transactionExists } =
    useContext(UpdateCompanyDetailsContext);

  const { transactionToEdit } = useContext(ManualTransactionEditContext);

  const existingTransaction = transactionExists(
    Constants.TRANSACTION_CHANGE_TYPES.CONVERSION
  );

  const isConversionTransaction =
    selectionsMade?.summary?.companyChanges?.some((change) =>
      ["conversionPLCtoPVT", "conversionPVTtoPLC"].includes(change)
    ) ||
    existingTransaction?._id ||
    transactionToEdit?.changeType ===
      Constants.TRANSACTION_CHANGE_TYPES.CONVERSION;

  if (!company?._id) return "loading...";

  const tabs = useMemo(() => {
    const commonTabs = [
      {
        id: "company",
        label: "Company Summary",
      },
      {
        id: "governance",
        label: "Governance Summary",
      },
      {
        id: "securities",
        label: "Securities",
      },
      {
        id: "annualCompliance",
        label: "Annual Compliance",
      },
    ];
    return commonTabs.filter((tab) => {
      if (tab.id === "company") {
        return selectionsMade?.summary?.companyChanges?.length > 0;
      } else if (tab.id === "governance") {
        return (
          selectionsMade?.summary?.governanceChanges?.length > 0 ||
          isConversionTransaction
        );
      } else if (tab.id === "securities") {
        return selectionsMade?.summary?.securities?.length > 0;
      } else if (tab.id === "annualCompliance") {
        return selectionsMade?.summary?.annualCompliance?.length > 0;
      }
      return false;
    });
  }, []);

  // Handle sub-tab navigation
  const handleSummaryNavigation = (direction) => {
    if (direction === "prev") {
      if (selectedTabIndex === 0) {
        handleGoBack(); // Navigate to previous parent tab
      } else {
        setSelectedTabIndex(selectedTabIndex - 1); // Previous sub-tab
      }
    } else if (direction === "next") {
      if (selectedTabIndex === tabs.length - 1) {
        handleGoForward(); // Navigate to next parent tab
      } else {
        setSelectedTabIndex(selectedTabIndex + 1); // Next sub-tab
      }
    }
  };

  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex, tabs]);

  return (
    <>
      <Tabs
        tabs={tabs}
        selectedTabIndex={selectedTabIndex}
        // setSelectedTabIndex={setSelectedTabIndex}
        showBorderBottom={false}
      />

      <>
        {selectedTab?.id === "company" && (
          <div>
            <CompanySummary handleSummaryNavigation={handleSummaryNavigation} />
          </div>
        )}
        {selectedTab?.id === "governance" && (
          <div>
            <Governance handleSummaryNavigation={handleSummaryNavigation} />
          </div>
        )}
        {selectedTab?.id === "securities" && (
          <div>
            <Securities handleSummaryNavigation={handleSummaryNavigation} />
          </div>
        )}
        {selectedTab?.id === "annualCompliance" && (
          <div>
            <AnnualCompliance
              handleSummaryNavigation={handleSummaryNavigation}
            />
          </div>
        )}
      </>
    </>
  );
};

export default Summary;
